<template>
    <div id="zipInfoInputDiv">
        <div id="zipTitle">
            {{ zipTitle }} <!--Free Home Delivery To-->
        </div>
        <div id="inputDiv">
            <input id="cityStateZip" type="text" autocomplete="off" @keydown.down="onArrowDown" @keydown.up="onArrowUp" @keydown.enter="onEnter" @keyup="onChange" @focus="newZipSearch" @blur="closeKeyboard"/>
            <ul id="autocomplete-results" v-show="isOpen" class="autocomplete-results">
                <li class="loading" v-if="isLoading">
                    Loading results...
                </li>
                <li v-else v-for="(result, i) in results" :key="i" @click="setResult(result)" class="autocomplete-result" :class="{ 'is-active': i === arrowCounter }" tabIndex="-1">
                    {{ result.city }}, {{ result.state }} {{ addLeadingZeros(result.zip) }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isOpen: false,
                results: [],
                isLoading: false,
                arrowCounter: 0,
                debounce: null
            }
        },
        computed: {
            destZip() {
                return this.$store.getters.getDestZip;
            },
            zipSearchResults() {
                return this.$store.getters.getSuggestedZips;
            },
            destZipDisplay() {
                return this.destZip.city + ", " + this.destZip.state + " " + this.addLeadingZeros(this.destZip.zip);
            },
            zipTitle() {
                return this.$store.getters.isMobile ? "Free Delivery To" : "Free Home Delivery To";
            }
        },
        watch: {
            destZip(newZip, oldZip) {
                if(newZip && newZip != oldZip) {
                    var searchText = document.getElementById('cityStateZip');
                    searchText.value = this.destZipDisplay;
                }
            },
            zipSearchResults(val) {
                this.results = val;
                this.isLoading = false;
            }
        },
        mounted() {
            document.addEventListener('click', this.handleClickOutside);
            this.updateSearchText(this.destZipDisplay);
        },
        unmounted() {
            document.removeEventListener('click', this.handleClickOutside)
        },
        methods: {
            getSearchText() {
                let searchText = document.getElementById('cityStateZip');
                
                return searchText.value;
            },
            updateSearchText(update) {
                let searchText = document.getElementById('cityStateZip');
                
                return searchText.value = update;
            },
            onChange(e) {
                if(e.keyCode != 13 && (e.keyCode < 37 || e.keyCode > 40)) {
                    this.isOpen = true;
                    this.$store.commit('updateDestZipSearch', this.getSearchText());
                    clearTimeout(this.debounce);
                    this.debounce = setTimeout(this.callZipSearch, 1200);
                    this.isLoading = true;
                }
            },
            newZipSearch() {
                this.updateSearchText("");
                this.$store.commit('updateMobileKeyboradStatus', true);
            },
            closeKeyboard() {
                this.$store.commit('updateMobileKeyboradStatus', false);
            },
            commitChangeToQuery() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('update', {'event_category': 'dest_zip','event_label': eventLabel});
                this.$store.commit('notifySearchQueryChanges', true);
            },
            setResult(result) {
                this.$store.dispatch('updateDestZip', result);
                this.commitChangeToQuery();
                this.closeSearch();
            },
            onArrowDown() {
                if (this.arrowCounter < this.results.length) {
                    this.arrowCounter = this.arrowCounter + 1;
                }
            },
            onArrowUp() {
                if (this.arrowCounter > 0) {
                    this.arrowCounter = this.arrowCounter -1;
                }
            },
            onEnter() {
                if(!this.isLoading && this.results && this.results.length > 0 && this.arrowCounter < this.results.length) {
                    this.setResult(this.results[this.arrowCounter]);
                }
                else {
                    this.isOpen = true;
                    this.isLoading = true;
                }
            },
            handleClickOutside(evt) {
                if (!this.$el.contains(evt.target)) {
                    if(this.$store.getters.getSuggestedZips) {
                        this.closeSearch();
                    }
                }
            },
            closeSearch() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('close', {'event_category': 'dest_zip','event_label': eventLabel});
                this.isOpen = false;
                this.arrowCounter = 0;
                this.updateSearchText(this.destZipDisplay);
            },
            callZipSearch() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('search', {'event_category': 'dest_zip','event_label': eventLabel});
                clearTimeout(this.debounce);
                this.$store.dispatch('searchForZip');
            },
            addLeadingZeros(zip) {
                zip = zip.toString();

                if(zip.length < 5) {
                    var leadingZeros = "";

                    for(var lz = 0; lz < (5 - zip.length); lz++) {
                        leadingZeros += "0";
                    }

                    zip = leadingZeros + zip;
                }

                return zip;
            }
        }
    }
</script>

<style>
    #zipInfoInputDiv {
        width: calc(10 * var(--vw));
        display:flex;
        flex-direction: column;
        justify-content: flex-end;
        max-width: calc(10 * var(--vw));
        align-items: center;
        height: fit-content; /*calc(10 * var(--vh));*/
    }

    .inmobile #zipInfoInputDiv {
        width: calc(46 * var(--vw));
        max-width: calc(46 * var(--vw));
        height: calc(8 * var(--vh));
        justify-content: space-evenly;
        align-items: center;
    }

    .inmobile.tabletstyle .landscape #zipInfoInputDiv {
        flex-direction: row;
    }

    #zipTitle {
        color: white;
        margin: calc(.2 * var(--vw)) calc(.2 * var(--vw)) calc(1 * var(--vh)) calc(.2 * var(--vw));
        font-size: calc(.8 * var(--vw));
    }

    .inmobile #zipTitle { 
        font-size: calc(3.6 * var(--vw));
    }

    .inmobile.tabletstyle .landscape #zipTitle {
        font-size: calc(2.5 * var(--vh));
    }

    #inputDiv {
        width: calc(8 * var(--vw));
        display: flex;
        justify-content: center;
        /*font-size: 1.05em;*/
        margin-bottom: calc(1 * var(--vh));
        color: var(--mccluskeyBlue);/*#0077C0;*/ /*#0079B6;*/
        font-size: calc((.8 * var(--vw)) + ((var(--vratio) - .5) * 1em)); /*calc(.5vw + ((1 - var(--vratio)) * 1em));*/
    }

    .inmobile #inputDiv {
		font-size: calc(2.1 * var(--vh));
        display: flex;
        flex-direction: row-reverse;
        justify-content: center;
        align-items: center;
        width: calc(45 * var(--vw));
        position: relative;
    }

    .inmobile.tabletstyle .landscape #inputDiv {
        width: 50%;
    }

    #inputDiv > input {
        color: var(--mccluskeyBlue);/*#0077C0;*/ /*#0079b6;*/
        text-align: center;
        font-size: inherit;
    }

    #cityStateZip {
        width: calc(8.5 * var(--vw));
        border-radius: calc(var(--vratio) * var(--vh));/*6px;*/
        border-top-style: hidden;
        border-right-style: hidden;
        border-left-style: hidden;
        border-bottom-style: groove;
        background-color: #eee;
        outline: none;
        padding: calc(.5 * var(--vh)) calc(.5 * var(--vw));
    }

    .inmobile #cityStateZip {
        width: calc(46 * var(--vw));
        border-radius: 5px;
    }

    ul.autocomplete-results {
        padding: 0;
    }
    
    .autocomplete-results {
        margin: 0;
        border: 1px solid #eeeeee;
        overflow: auto;
        height: fit-content;
        z-index: 3;
        background-color: #DFDFDF;
        color:black;
        position: absolute;
        width: calc(9 * var(--vw));
        left: calc(.4 * var(--vw));
        top: calc(23 * var(--vh));
        max-height: calc(60 * var(--vh));
        overflow: scroll;
        font-size: calc((1 * var(--vw)) + ((var(--vratio) - .5) * 1em)); /*calc(.5vw + ((1 - var(--vratio)) * 1em));*/
    }

    .inmobile .autocomplete-results {
        width: fit-content;
        right: calc(6 * var(--vw));
        top: calc(3 * var(--vh));
        z-index: 10;
		font-size: calc(2.1 * var(--vh));
    }
    
    .autocomplete-result {
        list-style: none;
        text-align: right;
        padding: 4px 2px;
        cursor: pointer;
    }
    
    .autocomplete-result.is-active,
    .autocomplete-result:hover {
        background-color: var(--mccluskeyGold); /*#AF873F;*/
        color: white;
    }
</style>